import React from "react";
import {useTranslation} from "react-i18next";

const Services = () => {
    const {t} = useTranslation();

    const services = t('services', {returnObjects: true});

    return (
        <div className="row">
            {services.map((val, i) => (
                <div className="col-lg-4 col-md-6 col-sm-6 col-12" key={i}>
                    <div className="service service__style--1">
                        <div className="content">
                            <h4 className="title">{val.title}</h4>
                            <p style={{textAlign: 'justify'}}>{val.description}</p>
                        </div>
                    </div>
                </div>
            ))}
        </div>
    )
}
export default Services;